import { useEffect } from 'react';

/**
 * Marca `data-desplazado` en la raíz cuando la pantalla ya no está arriba del todo.
 * Con eso la cabecera (`.topbar`) pasa de flotar sobre el fondo a ser una barra de
 * cristal: solo hace falta separar cuando hay contenido pasando por debajo.
 * Un solo oyente pasivo, a lo sumo una escritura por fotograma, y se recalcula al
 * cambiar de pantalla, que vuelve arriba sin disparar `scroll`.
 */
const UMBRAL_PX = 8;

export function useMarcaDesplazado(pathname: string): void {
  useEffect(() => {
    const raiz = document.documentElement;
    let pendiente = 0;
    const medir = () => {
      pendiente = 0;
      const desplazado = window.scrollY > UMBRAL_PX;
      if ((raiz.dataset['desplazado'] === 'true') !== desplazado) {
        raiz.dataset['desplazado'] = String(desplazado);
      }
    };
    const alDesplazar = () => {
      if (!pendiente) pendiente = requestAnimationFrame(medir);
    };
    medir();
    window.addEventListener('scroll', alDesplazar, { passive: true });
    return () => {
      window.removeEventListener('scroll', alDesplazar);
      if (pendiente) cancelAnimationFrame(pendiente);
    };
  }, [pathname]);
}
